import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, Inject, signal } from "@angular/core";
import { AccordionModule } from "core/components/accordion/accordion.module";
import { IconsModule } from "core/components/icons/icons.module";
import { iconFoldersArchive } from "main/icons/icon-folders-archive";
import { iconMoney } from "main/icons/icon-money";
import { iconDelivery } from "main/icons/icon-delivery";
import { iconHeart } from "main/icons/icon-heart";
import { iconUsersGroup } from "main/icons/icon-users-group";
import { iconWarehouse } from "main/icons/icon-warehouse";
import { iconServicesSquare } from "main/icons/icon-services-square";
import { iconMobileSquare } from "main/icons/icon-mobile-square";
import { iconEcommerceSquare } from "main/icons/icon-ecommerce-square";
import { iconInventorySquare } from "main/icons/icon-inventory-square";
import { DOCUMENT } from "@angular/common";
import { Router, RouterLinkActive } from '@angular/router';
import { LocaleService } from "src/app/locale/locale.service";
import { RoutesEnum } from "src/app/locale/routes.enum";
import { TranslateModule } from "@ngx-translate/core";
import { iconStopwatch } from "main/icons/icon-stopwatch";
import { ButtonTapDirective } from "core/directives/button-tap.directive";
import { TouchRouterLinkDirective } from "core/directives/touch-router-link.directive";
import { TouchHoverDirective } from "core/directives/touch-hover.directive";

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss'],
  imports: [AccordionModule, IconsModule, TouchHoverDirective, TouchRouterLinkDirective, ButtonTapDirective, TranslateModule, RouterLinkActive],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileMenuComponent implements OnInit, OnDestroy {
  readonly foldersIcon = iconFoldersArchive;
  readonly moneyIcon = iconMoney;
  readonly deliveryIcon = iconDelivery;
  readonly heartIcon = iconHeart;
  readonly teamIcon = iconUsersGroup;
  readonly warehouseIcon = iconWarehouse;
  readonly stopwatchIcon = iconStopwatch;

  readonly warehouseSquareIcon = iconInventorySquare;
  readonly servicesSquareIcon = iconServicesSquare;
  readonly mobileSquareIcon = iconMobileSquare;
  readonly ecommerceSquareIcon = iconEcommerceSquare;

  readonly routesEnum = RoutesEnum;

  readonly featuresLinks = [
    this.localeService.getLink(RoutesEnum.ACCOUNTING),
    this.localeService.getLink(RoutesEnum.SALES),
    this.localeService.getLink(RoutesEnum.PRODUCTS),
    this.localeService.getLink(RoutesEnum.PARTNERS),
    this.localeService.getLink(RoutesEnum.TEAM),
    this.localeService.getLink(RoutesEnum.INVENTORY_MANAGEMENT),
    this.localeService.getLink(RoutesEnum.TIME_TRACKING),
  ]

  readonly extensionsLinks = [
    this.localeService.getLink(RoutesEnum.SERVICES),
    this.localeService.getLink(RoutesEnum.RETAIL),
    this.localeService.getLink(RoutesEnum.ECOMMERCE),
  ];
  showFeatures = signal(false); 
  showExtensions = signal(false); 

  constructor(@Inject(DOCUMENT) private document: Document, public localeService: LocaleService, router: Router) {
    this.updateActiveMenu(router.url);
  }

  private updateActiveMenu(routerUrl: string) {
    this.showExtensions.set(
        this.extensionsLinks.some(f => f === decodeURIComponent(routerUrl))
    );
    this.showFeatures.set(
        this.featuresLinks.some(f => f === decodeURIComponent(routerUrl))
    );
  }

  ngOnInit(): void {
    this.document.documentElement.style.setProperty('overflow', 'hidden');
  }

  ngOnDestroy(): void {
    this.document.documentElement.style.setProperty('overflow', '');
  }
}